import React, { useEffect } from "react";

const ImagePopupModal = ({ showModal, imageData, onClose }) => {



  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);
  if (!showModal || !imageData) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[60]"
      onClick={onClose}
      aria-hidden={!showModal}
    >
      <div
        className="rounded-lg w-[80%] max-w-2xl bg- relative"
        onClick={(e) => e.stopPropagation()} 
      >
     
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-2xl font-bold bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-md hover:bg-gray-200"
          aria-label="Close Modal"
        >
          &times;
        </button>

     
        <div className="flex justify-center p-4">
          <img
            src={imageData.url}
            alt={`${imageData.type} image`}
            className="max-w-full max-h-[70vh] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ImagePopupModal;
